import React, { useEffect } from "react";

import CanalesStep1 from '../../Resources/Images/Tutoriales/Canales/Canales-1.jpg';
import StepTutorial from './index-step';

function getSteps() {
    return ['Paso 1'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return <StepTutorial image={CanalesStep1} text={['Hacer clic en “Canales” para ser redirigido al portal']} />
        default:
            return '¡Tutorial completado!';
    }
}

export function Canales({ activeStep, setSteps }) {
    const steps = getSteps();

    useEffect(() => {
        setSteps(steps);
    }, [setSteps, steps]);

    return (
        <>
            <h2>Canales</h2>
            <div className="d-flex justify-content-center mb-4">
                {steps.map((label, index) => (
                    <div
                        key={label}
                        className={`text-center mx-2 px-3 py-2 rounded ${index === activeStep ? 'bg-primary text-white' : 'bg-light text-secondary'}`}
                        style={{ minWidth: 80 }}
                    >
                        <div className="fw-bold">{label}</div>
                        <div className="small">Paso {index + 1}</div>
                    </div>
                ))}
            </div>

            <div>
                {getStepContent(activeStep)}
            </div>
        </>
    );
}
